import { Provider } from '@angular/core';
import { AsistenciaRepository } from './core/ports/asistencia.repository';
import { HttpAsistenciaRepository } from './core/adapters/http-asistencia.repository';
import { MedellinJovenCuentasPort } from './core/ports/medellin-joven-cuentas.port';
import { HttpMedellinJovenCuentasAdapter } from './core/adapters/http-medellin-joven-cuentas.adapter';
import { AsistenciaUiPort } from './core/ports/asistencia-ui.port';
import { MedellinJovenUiAdapter } from './core/adapters/medellin-joven-ui.adapter';
import { TiempoRealPort } from './core/ports/tiempo-real.port';
import { BroadcastTiempoRealAdapter } from './core/adapters/broadcast-tiempo-real.adapter';
import { CorreoPort } from './core/ports/correo.port';
import { OutboxCorreoSimuladoAdapter } from './core/adapters/outbox-correo-simulado.adapter';

/**
 * Providers de los puertos hexagonales del módulo de Asistencia MML
 * conectados a la infraestructura real de Medellín Joven.
 */
export function provideAsistenciaMml(): Provider[] {
  return [
    { provide: AsistenciaRepository, useExisting: HttpAsistenciaRepository },
    { provide: MedellinJovenCuentasPort, useExisting: HttpMedellinJovenCuentasAdapter },
    { provide: AsistenciaUiPort, useExisting: MedellinJovenUiAdapter },
    { provide: TiempoRealPort, useExisting: BroadcastTiempoRealAdapter },
    { provide: CorreoPort, useExisting: OutboxCorreoSimuladoAdapter }
  ];
}
